import { css, nothing } from 'lit'
import { html, unsafeStatic } from 'lit/static-html.js'
import HHQuizElement from '../element.js'

/**
 * Quiz modal info
 * @extends HHQuizElement
 */

class HHQuizModalInfo extends HHQuizElement {
  get data() {
    return this.store.currentModalData
  }

  get image() {
    return this.data.image
  }

  render() {
    return html`<hh-quiz-modal
      id="info"
      .size="${this.image ? 'lg' : 'md'}"
      .title="${this.data.title}"
    >
      <div class="hh-quiz-modal-info">
        ${this.image
          ? html`<div class="hh-quiz-modal-info__image">
              <img src="${this.image.src}" alt="${this.image.alt}" />
            </div>`
          : nothing}
        <div class="hh-quiz-modal-info__content">
          ${unsafeStatic(this.data.content)}
        </div>
      </div>
    </hh-quiz-modal>`
  }

  static styles = [
    HHQuizElement.styles,
    css`
      .hh-quiz-modal-info {
        display: flex;
        padding: 40px 25px 0px;
      }

      .hh-quiz-modal-info__image {
        margin-right: 40px;
        flex-grow: 1;
        max-width: max(23vw, 331px);
        min-width: 331px;
        margin-left: 20px;
        width: 100%;
        padding-bottom: 40px;
      }

      .hh-quiz-modal-info__image img {
        display: block;
        width: 100%;
      }

      .hh-quiz-modal-info__content {
        flex-grow: 1;
        max-height: max(412px, 49vh);
        overflow: auto;
        padding-right: 36px;
        padding-bottom: 40px;
      }

      @media screen and (max-width: ${HHQuizElement.mq.sm}px) {
        .hh-quiz-modal-info {
          display: block;
          padding: 25px;
        }
        .hh-quiz-modal-info__image {
          margin-right: 0;
          max-width: 100%;
          min-width: 100%;
          margin-left: 0;
          padding-bottom: 20px;
        }
        .hh-quiz-modal-info__content {
          max-height: none;
          padding-right: 0;
          padding-bottom: 10px;
          overflow: hidden;
        }
      }

      @media screen and (max-width: ${HHQuizElement.mq.xs}px) {
        .hh-quiz-modal-info {
          padding: 20px;
        }
      }
    `,
  ]
}

customElements.define('hh-quiz-modal-info', HHQuizModalInfo)
